import React, { useState } from 'react';
import { Box, Alert, Button, Collapse, alpha } from '@mui/material';

/**
 * FlowNotices — khu vực thông báo lỗi/cảnh báo của FlowEditor, TÁCH KHỎI thanh công cụ.
 *
 * Trước đây Alert nằm giữa Toolbar (flex 1, maxWidth 460): lỗi dài (vd. danh sách node thiếu trường
 * khi kiểm tra hợp lệ) kéo cao cả thanh công cụ, đẩy nút sang hàng khác -> giao diện bể.
 * Giờ mỗi thông báo là một dải mỏng ngay dưới thanh công cụ: mặc định chỉ hiện dòng đầu,
 * bấm "Xem chi tiết" mới bung ra (có giới hạn chiều cao + cuộn), đóng được từng cái.
 *
 * notices: [{ key, severity: 'error'|'warning'|'info', text, onClose? }]
 */
const NGUONG_DAI = 140; // ký tự — dài hơn (hoặc nhiều dòng) thì thu gọn

const Notice = ({ severity, text, onClose }) => {
  const [moRong, setMoRong] = useState(false);
  const chuoi = String(text || '');
  const cacDong = chuoi.split('\n');
  const dai = cacDong.length > 1 || chuoi.length > NGUONG_DAI;
  const dongDau = cacDong[0];

  return (
    <Alert
      severity={severity}
      onClose={onClose}
      action={dai ? (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Button color="inherit" size="small" onClick={() => setMoRong((v) => !v)}
            sx={{ textTransform: 'none', fontSize: 12, fontWeight: 700, minWidth: 0, px: 1, py: 0 }}>
            {moRong ? 'Thu gọn' : 'Xem chi tiết'}
          </Button>
        </Box>
      ) : undefined}
      sx={{
        py: 0, px: 1.5, borderRadius: 0, fontSize: 12, fontWeight: 600, alignItems: 'flex-start',
        borderBottom: '1px solid', borderColor: (t) => alpha(t.palette[severity]?.main || t.palette.divider, 0.2),
        '& .MuiAlert-icon': { py: '6px', mr: 1, fontSize: 18 },
        '& .MuiAlert-message': { py: '6px', minWidth: 0, flex: 1 },
        '& .MuiAlert-action': { py: '2px', pt: '2px', mr: 0 },
      }}
    >
      {!moRong && (
        <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={chuoi}>
          {dongDau}{dai && cacDong.length > 1 ? ` … (+${cacDong.length - 1} dòng)` : ''}
        </Box>
      )}
      <Collapse in={moRong} unmountOnExit>
        <Box sx={{ whiteSpace: 'pre-line', maxHeight: 180, overflowY: 'auto', pr: 1, wordBreak: 'break-word' }}>
          {chuoi}
        </Box>
      </Collapse>
    </Alert>
  );
};

const FlowNotices = ({ notices }) => {
  const list = (notices || []).filter((n) => n && n.text);
  if (!list.length) return null;
  return (
    <Box sx={{ flexShrink: 0, zIndex: 3 }}>
      {list.map((n) => <Notice key={n.key} severity={n.severity} text={n.text} onClose={n.onClose} />)}
    </Box>
  );
};

export default FlowNotices;
